import { render, staticRenderFns } from "./people_index.vue?vue&type=template&id=57c3c810"
import script from "./people_index.vue?vue&type=script&lang=js"
export * from "./people_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports